import { render, staticRenderFns } from "./AbhaConsent.vue?vue&type=template&id=20699deb&scoped=true"
import script from "./AbhaConsent.vue?vue&type=script&lang=js"
export * from "./AbhaConsent.vue?vue&type=script&lang=js"
import style0 from "./AbhaConsent.vue?vue&type=style&index=0&id=20699deb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20699deb",
  null
  
)

export default component.exports